import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/invoice-lots.js';
import form from '../forms/invoice-lots.js';
import * as types from '../types.js';

const invoiceLots = function()
{

	let invoice_lots_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_invoice_lots, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_invoice_lot, ...JSON.parse(id));
			_record['invoices'] = _record['invoices'].map(invoice => String(invoice)).join(' ');
			return _record;
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				type: data.type,
				invoices: data.invoices.split(' ').map(invoice => Number(invoice)),
			};
			if (old_data)
				return await api.call(api.update_invoice_lot, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_invoice_lot, data.company_id, _record);
		},
		sendLots()
		{
			const showResult = (resp) =>
			{
				notify(`Lotes transmitidos: ${resp?.count || 0}`, 'Resultado');
				this.loadPage();
			}
			const sendRequest = async () =>
			{
				let ids = await this.getSelectedIds(['company_id', 'id']);
				let resp = await api.call(api.send_invoice_lots, { 'ids': ids }).then(showResult);
			}
			ask(`Transmitir ${this.getCount()} lotes para a Sefaz?`, 'Confirmação', (answer) =>
			{
				if (answer == 'Y')
					sendRequest();
			});
		},
		queryLots()
		{
			const showResult = (resp) =>
			{
				notify(`Lotes consultados: ${resp?.count || 0}`, 'Resultado');
				this.loadPage();
			}
			const sendRequest = async (data) =>
			{
				let ids = await this.getSelectedIds(['company_id', 'id']);
				let resp = await api.call(api.query_invoice_lots, { 'ids': ids }).then(showResult);
			}
			ask(`Consultar ${this.getCount()} lotes com a Sefaz?`, 'Confirmação', (answer) =>
			{
				if (answer == 'Y')
					sendRequest();
			});
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Lote', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do lote' },
		{ index: 4, field: 'type', label: 'Tipo', types: [types.opt_invoice_lot_type(), types.datalist()], placeholder: '', title: 'Tipo de lote' },
		{ index: 6, field: 'receipt', label: 'Recibo', types: [types.nfe_receipt()], placeholder: '0', title: 'Número do recibo do lote' },
		{ index: 8, field: 'result_code', label: 'Código', types: [types.number(0, 2)], placeholder: '0', title: 'Código de retorno da última operação' },
		{ index: 9, field: 'result_text', label: 'Mensagem', types: [], placeholder: '', title: 'Mensagem de retorno da última operação' },
		{ index: 10, field: 'result_datetime', label: 'Data/Hora', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora da última operação' },
		{ index: 5, field: 'state', label: 'Estado', types: [types.opt_uf, types.datalist()], placeholder: '', title: 'Unidade Federativa' },
		{ index: 3, field: 'environment', label: 'Ambiente', types: [types.opt_environment(), types.datalist()], placeholder: '', title: 'Ambiente de envio' },
		{ index: 12, field: 'in_contingency', label: 'Contingência', types: [types.opt_bool(), types.datalist()], placeholder: '', title: 'Envio em contingência' },
	];

	let operations = [
		{ hash: '#send-lots',	label: 'Transmitir&nbsp;lotes&nbsp;para&nbsp;Sefaz'	},
		{ hash: '#query-lots',	label: 'Consultar&nbsp;lotes&nbsp;pendentes'		}
	];

	router.set('#send-lots', invoice_lots_crud.sendLots.bind(invoice_lots_crud));
	router.set('#query-lots', invoice_lots_crud.queryLots.bind(invoice_lots_crud));

	invoice_lots_crud.run(
		'invoice_lots',
		'Lotes&nbsp;Notas',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations
	);

};

export default invoiceLots;

